export default __webpack_public_path__ + "static/media/HappyBirthday_11.90fd29f4.png";